module.exports = __webpack_public_path__ + "img/xt.0cd00761.svg";